import { Route, Routes } from "react-router-dom"
import NotFound404 from "../pages/NotFound404"
import RequireAuth from "../components/Authentication/RequireAuth";
import PersistLogin from "../components/Authentication/PersistLogin";
import SettingsPage from "../pages/SettingsPage";

const SettingsRouter = () => {
    return (
            <Routes>
                <Route element={<PersistLogin />}>
                    <Route element={<RequireAuth allowedRoles={["100"]} />}>
                        <Route path="/" element={<SettingsPage />} />                    
                        <Route path="*" element={<NotFound404 />} />
                    </Route>
                </Route>
            </Routes>
    )
}

export default SettingsRouter;